import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { beforeRanking, getRankings } from './rankings.action';
import FullPageLoader from '../full-page-loader/full-page-loader';
import Pagination from 'rc-pagination';
import localeInfo from 'rc-pagination/lib/locale/en_US';
import { ENV } from "../../config/config";
import Select from 'react-select';

const Rankings = (props) => {
    const [loader, setLoader] = useState(true)
    const [stats, setStats] = useState(null)
    const [pagination, setPagination] = useState(null)
    const [categories, setCategories] = useState(null)

    // for filters only
    const [filter, setFilter] = useState(null)

    useEffect(() => {
        window.scroll(0, 0)
        getRankings({ getCategories: true })
    }, [])

    useEffect(() => {
        if (props.rankings.statsAuth) {
            const { stats, pagination, categories, getCategories } = props.rankings.stats
            setLoader(false)

            // set stats & it's pagination
            setStats(stats)
            setPagination(pagination)

            // set categories on first call only
            if (getCategories)
                setCategories(categories)

            props.beforeRanking()
        }
    }, [props.rankings.statsAuth])

    const onPageChange = async (page) => {
        getRankings({ page })
    }

    const getRankings = (filter) => {
        setLoader(true)
        const qs = ENV.objectToQueryString(filter)
        props.getRankings(qs)
    }

    const handleChange = (selectedOption, select) => {
        const filterData = {
            ...filter,
        }

        if (selectedOption)
            filterData[select.name] = selectedOption?.value || null
        else
            delete filterData[select.name]

        setFilter(filterData)
        getRankings(filterData)
    }


    return (
        <section className="activity-area load-more">
            {loader && <FullPageLoader />}
            <div className="container">
                {/* intro */}
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-7">
                        <div className="intro text-center">
                            {/* <span>Rankings</span> */}
                            <h3 className="mt-3 mb-0">Top NFTs</h3>
                            <p>The top NFTs on {ENV.appName}, ranked by volume and other statistics.</p>
                        </div>
                    </div>
                </div>

                {/* filters */}
                <div className="my-4">
                    <div className="col-sm-12 col-md-4">
                        {
                            categories &&
                            <Select
                                options={categories}
                                value={categories.filter(option => option.value === (filter?.categoryId || null))}
                                onChange={handleChange}
                                className="select-custom-style"
                                placeholder="Select Category"
                                classNamePrefix="custom-select"
                                name="categoryId"
                                styles={{
                                    menu: (provided, state) => ({
                                        ...provided,
                                        color: state.isDisabled ? 'grey' : 'hsl(0,0%,20%)',
                                        cursor: state.isDisabled ? 'not-allowed' : 'pointer'
                                    })
                                }}
                                isClearable={true}
                                isSearchable={false}
                            />
                        }
                    </div>
                </div>

                {/* rankings */}
                <div className="row items">
                    <div className="col-12 table-responsive">
                        <table className="table table-borderless table-dark">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Collection</th>
                                    <th scope="col">Volume</th>
                                    <th scope="col">24h%</th>
                                    <th scope="col">7d%</th>
                                    <th scope="col">Owners</th>
                                    <th scope="col">Assets</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    stats && stats.length ?
                                        stats.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <th scope="row">{pagination && ((pagination.limit * pagination.page) - pagination.limit) + index + 1}</th>
                                                    <td>
                                                        <Link className="d-flex ranking-collection-name" to={`collection-details/${window.btoa(item.collection._id)}`}>
                                                            <p className="p-2">
                                                                {item.collection.name}
                                                            </p>
                                                            <p className="p-1">
                                                                <img className="rounded-circle" src={item.collection.logo} alt="img" />
                                                            </p>
                                                        </Link>
                                                    </td>
                                                    <td>{item.volume ? item.volume : 0}</td>
                                                    <td>{item.p24h ? item.p24h : '---'}</td>
                                                    <td>{item.p7d ? item.p7d : '---'}</td>
                                                    <td>{item.owners ? item.owners : '---'}</td>
                                                    <td>{item.assets ? item.assets : '---'}</td>
                                                </tr>
                                            )
                                        })
                                        :
                                        <tr><td colSpan="7" className="text-center">No Data Found</td></tr>
                                }
                            </tbody>
                        </table>
                        {
                            pagination && pagination.total > 0 &&
                            <Pagination
                                defaultCurrent={1}
                                pageSize // items per page
                                current={pagination.page} // current active page
                                total={pagination.pages} // total pages
                                onChange={onPageChange}
                                locale={localeInfo}
                            />
                        }
                    </div>
                </div>
            </div>
        </section>
    );
}

const mapStateToProps = state => ({
    rankings: state.rankings
});

export default connect(mapStateToProps, { beforeRanking, getRankings })(Rankings);